import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Link as MuiLink,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PreviewIcon from "@mui/icons-material/Preview";
import DownloadIcon from "@mui/icons-material/Download";
import "../App.css";

const AdditionalFileViewPopup = ({ open, onClose, files }) => {
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
  });

  const handleDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error while downloading the file", error);
    }
  };
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "FileName",
      headerName: "File Name",
      width: 400,
      headerClassName: "bold-header",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <MuiLink
          href={params.row.FileUrl}
          target="_blank"
          underline="hover"
          sx={{
            color: "text.primary",
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          {params.row.FileName}
        </MuiLink>
      ),
    },
    {
      field: "FileUrl",
      headerName: "File Url",
      width: 150,
      headerClassName: "bold-header",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip title="Preview File" arrow>
          <IconButton
            component="a"
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
          >
            <PreviewIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
      ),
    },
    {
      field: "Download",
      headerName: "Download",
      width: 150,
      headerClassName: "bold-header",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip title="Download File" arrow>
          <IconButton
            onClick={() =>
              handleDownload(params.row.FileUrl, params.row.FileName)
            }
            color="success"
          >
            <DownloadIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  // Define initial sort model
  const sortModel = [
    {
      field: "FileName", // Sort by the FileName column
      sort: "asc", // 'asc' for ascending order, 'desc' for descending
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Additional Files</DialogTitle>
      <DialogContent>
        <DataGrid
          rows={files}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10, 50, 100]}
          disableSelectionOnClick // Disable row selection
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          sortModel={sortModel} // Set initial sort model
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdditionalFileViewPopup;
